<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="opened" persistent max-width="450" light>
        <v-card>
          <v-card-title class="headline">Copier/coller</v-card-title>
          <v-divider />
          <v-form ref="form" v-model="isValid">
            <v-card-text class="mt-3">
              <v-textarea
                v-model="input"
                item-color="info"
                menu-props="light"
                color="blue"
                clearable
                rows="3"
                label="Chaîne de caractères"
                :rules="[rules]"
              />
            </v-card-text>
          </v-form>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              :disabled="!isValid"
              color="success"
              small
              @click="save"
            >
              Copie
            </v-btn>
            <v-btn color="info" small @click="closePopup">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import moment from 'moment';
import { EventBus } from '../../../mixins';

const slugify = require('slugify');

const opened = ref(false);
const fieldConfig = ref({});
const input = ref('');
const form = ref(null);
const isValid = ref(false);

const values = computed(() => {
  console.log('test', input.value);
  let value = [];
  if (input.value.trim()) {
    value = input.value.split(',');
  }
  return value;
});

const rules = computed(() => {
  // EMPTY FIELD VALIDATE
  if (!input.value || !input.value.trim()) {
    return 'Required';
  }

  // NUMERIC VALIDATE
  if (fieldConfig.value && fieldConfig.value.allLogicOperators) {
    if (values.value.some(isNaN)) {
      return 'Numeric Field';
    }
  }

  // DATE VALIDATE
  if (fieldConfig.value && fieldConfig.value.formatLabel === 'date') {
    if (values.value.find(d => moment.unix(d.trim()).isValid() === false)) {
      return 'Invalid Timestamp';
    }
  }

  return true;
});

const open = config => {
  fieldConfig.value = config;
  opened.value = true;
};

const closePopup = () => {
  EventBus.$off('copyPasteValues');
  opened.value = false;
  input.value = '';
  form.value.reset();
};

const save = () => {
  // config data
  const slugifyOptions = {
    replacement: '-',
    remove: /[*+~.()'"!:@]/g,
    lower: true
  };
  const copyPasteValues = [];

  values.value.forEach(value => {
    value = value.trim();
    if (value.length) {
      const createPasteValue = { value: value, label: value };

      if (fieldConfig.value && fieldConfig.value.formatLabel === 'date') {
        createPasteValue.label = moment.unix(value).format('DD/MM/YYYY');
      }

      if (fieldConfig.value && fieldConfig.value.formatValue === 'slugify') {
        createPasteValue.value = slugify(value, slugifyOptions);
      }

      copyPasteValues.push(createPasteValue);
    }
  });

  // this event is always closed when a popup was closed to refresh a reference
  EventBus.$emit('copyPasteValues', copyPasteValues);

  closePopup();
};

// eslint-disable-next-line no-undef
defineExpose({ open });

</script>
